<template>
  <div class="precautions">
    <div class="precautions_inner bg-white p-6">
      <div class="d-flex align-items-center justify-content-center w-100">
        <div class="max-w-3xl leading-loose p-3">
          <p  class="text-lg font-black text-left" v-html="displayDescription"></p>
        </div>
      </div>

      <TestingTools_speaking :questionData="questionData" v-if="$route.params.practice_type === 'speaking'" />
      <TestingTools_writing :questionData="questionData" v-if="$route.params.practice_type === 'writing'" />
    </div>
  </div>
</template>

<script>
  import TestingTools_speaking from '@/components/AiHelper/GEPT/TestingTools_speaking'
  import TestingTools_writing from '@/components/AiHelper/GEPT/TestingTools_writing'
  import geptI18n from '@/components/AiHelper/GEPT/i18n'

  export default {
    // 注意事項
    name: 'Precautions',
    mixins: [
      geptI18n
    ],

    data () {
      return {}
    },
    props: {
      title: {
        type: String
      },
      level: {
        type: String
      },
      unit: {
        type: String
      },
      questionData: {
        type: Object
      }
    },

    computed: {
      displayDescription () {
        return this.geptPrecautionDescription(this.level, this.unit, this.title)
      }
    },

    components: {
      TestingTools_speaking,
      TestingTools_writing
    }
  }
</script>

<style lang="scss" scoped>
.precautions {
  .precautions_inner {
    min-height: calc(60vh);
  }
}
</style>
